module.exports = __webpack_public_path__ + "img/non_binary-placeholder.4ffbe960.svg";